/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/rewards/reward_redemption_settings';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "UpdateRewardRedemptionSettingsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rewardRedemptionSettings": {
                    "type": ".squareup.corporate_card.resources.rewards.RewardRedemptionSettings",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateRewardRedemptionSettingsResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateRewardRedemptionSettingsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateRewardRedemptionSettingsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateRewardRedemptionSettingsRequest @ squareup/corporate_card/service/update_reward_redemption_settings.proto at 10:1
 */
export const UpdateRewardRedemptionSettingsRequest = $root.lookupType('squareup.corporate_card.service.UpdateRewardRedemptionSettingsRequest');
fixType(UpdateRewardRedemptionSettingsRequest, {
  creditLineId: {
    notEmpty: true
  },
  rewardRedemptionSettings: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateRewardRedemptionSettingsRequest);
/**
 * SOURCE UpdateRewardRedemptionSettingsResponse @ squareup/corporate_card/service/update_reward_redemption_settings.proto at 29:1
 */
export const UpdateRewardRedemptionSettingsResponse = $root.lookupType('squareup.corporate_card.service.UpdateRewardRedemptionSettingsResponse');
fixType(UpdateRewardRedemptionSettingsResponse);
Builder.createAndAttachToType(UpdateRewardRedemptionSettingsResponse);